/**
 * Created by Victor Rojo on 20/9/18.
 */
import {Component, Input, OnDestroy} from '@angular/core';

import {PricePoleWidget} from "../../widget/Widget";
import {IPlaceDataChangeService} from "../../IPlaceDataChange.service";
import {WidgetStatusChangeAware} from "../base-widget/WidgetStatusChangeAware";
import {PricePole} from "../../ipetrol/PricePole";


@Component({
  selector: 'price-pole',
  templateUrl: './PricePole.component.html',
  styleUrls: ['./PricePole.component.css']
})
export class PricePoleComponent extends WidgetStatusChangeAware{
  status:string = "";
  subscriptions: any[] = [];
  salesInfo:boolean = true;

  constructor(private iPlaceDataChangeService1: IPlaceDataChangeService) {
    super(iPlaceDataChangeService1);
    this.subscriptions.push(this.iPlaceDataChangeService1.pricePoleChange$.subscribe( (pricePole:PricePole) => {
      let pricePoleWidget = this._widget as PricePoleWidget;
      if ( pricePole.pricePoleId == pricePoleWidget.pricePoleId ) {
        pricePoleWidget.status = pricePole.status;
        pricePoleWidget.updated = pricePole.updated;
        pricePoleWidget.priceOptions = pricePole.priceOptions;
        this.updateStatus();
      }
    }));
  }

  get widget(): PricePoleWidget {
    return this._widget as PricePoleWidget;
  }

  @Input()
  set widget(pumpWidget: PricePoleWidget) {
    this._widget = pumpWidget;
    this.updateStatus();
    this.salesInfo = pumpWidget.salesInfo;
  }

  updateStatus(){
    let pricePoleWidget = this._widget as PricePoleWidget;
    if ( pricePoleWidget.status ){
      this.status = "ON";
    } else {
      this.status = "OFF";
    }
  }

  public ngOnDestroy(): void {
    super.ngOnDestroy();
    this.subscriptions.forEach(subscription => subscription.unsubscribe());
  }
}
